export class ScenarioPrograms {
  standard: string[];
  custom: string[];

  constructor() {
    this.standard = [];
    this.custom = [];
  }
}
